/* eslint-disable no-param-reassign */
/* eslint-disable no-multi-assign */
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import Checkbox from '@material-ui/core/Checkbox';
import { connect } from 'react-redux';
import SectionHeader from '../../components/sectionHeader';
import bellIcon from '../../icons/bellIcon2.svg';
import styles from './notifications.module.scss';
import { fetchPortalTilesList, postPortalTilesList, clear } from '../home/redux/actions';
import { changeCurrentPage } from '../../general_redux/actions';

class SubscriptionLayout extends Component {
  constructor() {
    super();
    this.state = {
      newTiles: []
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (props?.portalTiles?.length !== state?.newTiles?.length) {
      return {
        newTiles: props?.portalTiles?.filter(
          tile => tile.system_generated === false && tile.visibility === true
        )
      };
    }
    return null;
  }

  componentDidMount() {
    const { actionFetchPortalTiles, actionUpdateCurrentPage } = this.props;
    actionFetchPortalTiles();
    actionUpdateCurrentPage('Airport Portal');
  }

  toggleChange = (index) => {
    const { newTiles } = this.state;
    const { actionPostPortile } = this.props;
    if (index.id) {
    const dataObj = (index.subscribed = !index.subscribed);
    const object = { Subscribe: dataObj };
    actionPostPortile(index.id, object);
    this.setState({
      newTiles
    });
  }
  };

  render() {
    const { newTiles } = this.state;
    return (
      <>
        <SectionHeader
          icon={bellIcon}
          translationID="subscriptions.title"
          defaultTitle="Subscriptions"
        />

        <div className={styles.container}>
          <div className={styles.subcontainer1}>
            <div className={styles.head_padding}>
              <span className={styles.head}>
                <FormattedMessage
                  id="notification.airfield.workorders"
                  defaultMessage="Subscribe Content"
                />
              </span>
            </div>
            <hr />
            {newTiles?.map(wo => (
              <>
                <div key={wo.id}>
                  <span className={styles.data}>{wo.tile_name}</span>
                  <span className={styles.toggle}>
                    <Checkbox
                      id={wo.id}
                      checked={wo.subscribed}
                      color="primary"
                      style={{ marginTop: '-10px' }}
                      onChange={() => this.toggleChange(wo)}
                    />
                  </span>
                </div>
                <hr />
              </>
            ))}
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
  portalTiles: state.home.portalTilesList
});

const mapDispatchToProps = dispatch => ({
  actionPostPortile: (id, data) => {
    dispatch(postPortalTilesList(id, data));
  },
  actionFetchPortalTiles: () => {
    dispatch(fetchPortalTilesList());
  },
  actionClear: () => {
    dispatch(clear());
  },
  actionUpdateCurrentPage: (page) => {
    dispatch(changeCurrentPage(page));
  }
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(SubscriptionLayout));
